/**
 * PowerArQ TOPページ リデザイン 2026
 * 1. スクロールフェードインアニメーション
 * 2. セクション背景交互パターン
 *
 * スコープ: template-index（TOPページ）のみ実行
 */
(function () {
  'use strict';

  function init() {
    // TOPページ以外では実行しない（magazine等に干渉しない）
    if (!document.body.classList.contains('template-index')) {
      return;
    }

    var sections = document.querySelectorAll('.index-section');

    // --- スクロールフェードイン ---
    if (!('IntersectionObserver' in window)) {
      // Observer非対応: 全セクション即表示
      sections.forEach(function (el) {
        el.classList.add('is-visible');
      });
      document.querySelectorAll('.newsletter-top-section').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    var allSections = document.querySelectorAll('.index-section, .newsletter-top-section');
    allSections.forEach(function (section) {
      // ショートカルーセル・NEWSバナーはスキップ（最初から表示）
      if (
        section.classList.contains('shorts-carousel') ||
        section.classList.contains('powerarq-news-banner-section')
      ) {
        section.classList.add('is-visible');
        return;
      }
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * 取扱説明書ページ: 製氷機カテゴリ補助挿入
 *
 * Shopifyの翻訳本文が公開側で優先される場合に備え、
 * instructionsページ上でのみ製氷機カテゴリとカードを追加する。
 */
(function () {
  'use strict';

  function initIceMakerInstructions() {
    var isInstructionsPage = document.body.classList.contains('template-page--instructions') ||
      window.location.pathname === '/pages/instructions';

    if (!isInstructionsPage || document.getElementById('ice-maker')) {
      return;
    }

    var summerButton = document.querySelector('.category-button[data-target="summer-appliances"]');
    var summerSection = document.getElementById('summer-appliances');

    if (!summerButton || !summerSection) {
      return;
    }

    var categoryButton = document.createElement('a');
    categoryButton.href = '#ice-maker';
    categoryButton.className = 'category-button';
    categoryButton.setAttribute('data-target', 'ice-maker');
    categoryButton.textContent = '製氷機';
    summerButton.insertAdjacentElement('afterend', categoryButton);

    var section = document.createElement('section');
    section.className = 'download-section';
    section.id = 'ice-maker';
    section.innerHTML = [
      '<h2 class="section-title">製氷機</h2>',
      '<div class="download-grid">',
      '  <div class="download-card">',
      '    <a href="https://sm-tap.com/instruction/A0080_Manual.pdf" target="_blank" class="card-image-link">',
      '      <div class="card-image"><img alt="PowerArQ Ice Cube Maker" src="https://cdn.shopify.com/s/files/1/0349/9160/3850/files/powerarq_ice_cube_maker_icon_v2.jpg?v=1778636916"></div>',
      '    </a>',
      '    <div class="card-content">',
      '      <h3 class="card-title">PowerArQ Ice Cube Maker</h3>',
      '      <a class="download-link" href="https://sm-tap.com/instruction/A0080_Manual.pdf" target="_blank"><i class="fas fa-download"></i>ダウンロードはこちら</a>',
      '    </div>',
      '  </div>',
      '</div>'
    ].join('');

    summerSection.insertAdjacentElement('afterend', section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIceMakerInstructions);
  } else {
    initIceMakerInstructions();
  }
})();
